/**
 * Post Detail Page
 * Shows a single post on its own page (shareable URL: /post/:id).
 */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import SinglePostDisplay from '../components/post/SinglePostDisplay';

const PostDetailPage = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPost = useCallback(async () => {
    try {
      const response = await axios.get(`/api/posts/${id}`);
      setPost(response.data);
    } catch (error) {
      console.error('Error fetching post:', error);
      setPost(null);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchPost();
  }, [fetchPost]);

  if (loading) {
    return <div className="container loading">Loading post...</div>;
  }

  if (!post) {
    return (
      <div className="container">
        <p>Post not found.</p>
        <Link to="/feed">← Back to feed</Link>
      </div>
    );
  }

  return (
    <div className="container">
      <Link to="/feed" className="back-link">← Back to feed</Link>
      <div className="posts-list">
        <SinglePostDisplay post={post} onUpdate={fetchPost} />
      </div>
    </div>
  );
};

export default PostDetailPage;
